import React, { useEffect } from "react";
import { Navigate } from "react-router-dom";
import authStore from "../../store/authStore";
import MyLoader from "../../components/myLoader/MyLoader";

const RequireAuth = (props) => {
  const store = authStore();
  useEffect(() => {
    if (store.isLogged === null) {
      store.checkAuth();
    }
  }, []);

  if (store.isLogged === null) {
    return <MyLoader height="100vh" />;
  }

  if (store.isLogged === true) {
    return <Navigate to="/" />;
  }

  return <div>{props.children}</div>;
};

export default RequireAuth;
